const baseUrl = 'http://0.0.0.0:5444/'
const baseUrlProd = 'https://api1.competiscan.com/contentsite-search-fast-api/v1/'

// const spacybaseUrlProd = 'https://dev02.competiscan.com:8080/api/v4.0/showhtml/'

const baseUrlCompany = 'http://127.0.0.1:5000/api/v3.0/'
const baseUrlCompanyProd = 'https://dev02.competiscan.com:8080/api/v6.0/'

const baseUrlProductv2 = 'https://product-entry.competiscan.com/'
const baseUrlProductv2Prod = 'https://product-entry.competiscan.com/' 

const baseUrlCompany2019 = 'http://52.32.33.145:8080/api/v4.0/'
const baseUrlCompany2019Prod = 'https://dev02.competiscan.com:8080/api/v5.0/'
const VisualizeUrl = 'http://127.0.0.1:5000/api/v1.0/email'
const VisualizeUrlProd = 'https://dev02.competiscan.com:8080/api/v4.0/visulaize'
// const baseemaildetailUrl='http://127.0.0.1:5555'
// const baseemaildetailUrlProd='https://dev02.competiscan.com:9443'

const html_pdf_service_url_local = 'https://dev02.competiscan.com:5450/'
const html_pdf_service_url_prod = 'https://api3.competiscan.com/html-pdf/v2/'
const render_html_url = 'https://api3.competiscan.com/html-pdf/v2/html/'
const render_processed_html_url = 'https://api3.competiscan.com/html-pdf/v2/processedhtml/'
const render_apc_process_url = 'https://api3.competiscan.com/html-pdf/v2/apc_process/'
const render_pdf_url = 'https://api3.competiscan.com/html-pdf/v2/temppdf/'
const render_company_url_local = 'http://localhost:8080/company/'
const render_company_url_prod = 'https://cs.competiscan.com/company/'
const all_prediction_url_local = 'https://dev02.competiscan.com:8080/api/v1.0/allmodelspredctions'
const all_prediction_url_prod = 'https://api1.competiscan.com/companyprediction/v1/api/v1.0/allmodelspredctions'
const sector_url_local = 'https://dev02.competiscan.com:5002/api/v1.0/sectorprediction'
const sector_url_prod = 'https://api.competiscan.com/sectorpred/v1/api/v1.0/sectorprediction'
const category_url_local = 'https://dev02.competiscan.com:5039/api/v1.0/categoryprediction'
const category_url_prod = 'https://api.competiscan.com/categorypred/v1/api/v1.0/categoryprediction'
const mailingtype_url_local = 'https://dev02.competiscan.com:5006/api/v1.0/mtypeprediction'
const mailingtype_url_prod = 'https://api.competiscan.com/mailingtypepred/v1/api/v1.0/mtypeprediction'
const seccompany_url_local = 'https://dev02.competiscan.com:5008/api/v1.0/companyprediction'
const seccompany_url_prod = 'https://api.competiscan.com/autotrain-custommodel/v1/api/v1.0/companyprediction'


const baseUrlApi = 'http://127.0.0.1:5053/'
const baseUrlApiProduction = 'https://api2.competiscan.com/product/v1/'

const sendmailURL_local = "https://search-dev01.competiscan.com/forwardto"
const sendmailURL_prod = "https://api1.competiscan.com/contentsite-search-fast-api/v1/forwardto"
const getForwardApiURL_local = "https://search-dev01.competiscan.com/forwardto"
const getForwardApiURL_prod = "https://api1.competiscan.com/contentsite-search-fast-api/v1/forwardto"
const getAttachements_local = "https://search-dev01.competiscan.com/attachments"
const getAttachements_prod = "https://api1.competiscan.com/contentsite-search-fast-api/v1/attachments"
const deleteemailapi_local = "https://search-dev01.competiscan.com/forwardto"
const deleteemailapi_prod = "https://api1.competiscan.com/contentsite-search-fast-api/v1/forwardto"
const downloadapi_local = "https://search-dev01.competiscan.com/download"
const downloadapi_prod = "https://api1.competiscan.com/contentsite-search-fast-api/v1/download"
const uploadattachment_local = "https://search-dev01.competiscan.com/attachments"
const uploadattachment_prod = "https://api1.competiscan.com/contentsite-search-fast-api/v1/attachments"
const tiny_mce = "bqearslt97ldo82bdfdgxkuptzz3467t79pzyx8lsts8mg52"
const companyPredProd = 'https://api1.competiscan.com/companyprediction/v1/api/v1.0/companyprediction/'
const upload_pdf_base_url = "http://0.0.0.0:5054/"
// const upload_pdf_base_url_prod = "http://0.0.0.0:5054/"
const upload_pdf_base_url_prod = "https://api2.competiscan.com/product/v1/"
const ml_annotation_tool_base_url = "http://0.0.0.0:5408/"
const ml_annotation_tool_base_url_prod = "http://vat.competiscan.com/"
const product_admin_listing = "https://admin.competiscan.com/directm-ProcessProduct"
const direct_mail_temp_grid = "https://admin.competiscan.com/directm-temp-product"
const upload_endpoint = "https://dev02.competiscan.com:5418/"
const upload_endpoint_prod = "https://api2.competiscan.com/uploads/v1/"
const archeive_link = "https://admin.competiscan.com/product-archieve"
const send_email_link = "https://search-dev01.competiscan.com/sendetocollegue"
const send_email_link_prod = "https://api1.competiscan.com/contentsite-search-fast-api/v1/sendetocollegue"
const newProductEntry = "https://api2.competiscan.com/product-entry/v1/"

const dashboards = [
    'dashboard',
    'producer',
    'consumer',
    'mortgage',
    'provider',
    'home'
]

module.exports = {
    emailsUrl: baseUrl + 'emails',
    emailUrl: baseUrl + 'email',
    rawData: baseUrl + 'data/rawdata',
    searchUrl: baseUrl + 'search',
    updateFlag: baseUrl + 'emails/updateflag',
    updatePanelistScore: baseUrl + 'emails/updatepanelistscore',
    updateStatus: baseUrl + 'emails/updatestatus',
    updateMark: baseUrl + 'emails/updatemark',
    headerJson: "application/json",
    emailsUrlProd: baseUrlProd + 'emails',
    emailUrlProd: baseUrlProd + 'email',
    emaildetailUrl: baseUrl + 'emaildetail',
    emaildetailUrlProd: baseUrlProd + 'emaildetail',
    // forwardemailUrl:baseemaildetailUrl,
    forwardemailUrl: baseUrl + 'emailhistory',
    forwardemailUrlProd: baseUrlProd + 'emailhistory',
    htmlbodyUrl: baseUrl + 'emailhtml',
    htmlbodyUrlProd: baseUrlProd + 'emailhtml',
    emailsaveUrl: baseUrl + 'emaildetail',
    emailsaveUrlProd: baseUrlProd + 'emaildetail',
    updatescore_local: baseUrl + 'updatescore',
    updatescore_prod: baseUrlProd + 'updatescore',
    rawDataProd: baseUrlProd + 'data/rawdata',
    searchUrlProd: baseUrlProd + 'search',
    updateFlagProd: baseUrlProd + 'emails/updateflag',
    updatePanelistScoreProd: baseUrlProd + 'emails/updatepanelistscore',
    updateStatusProd: baseUrlProd + 'emails/updatestatus',
    updateMarkProd: baseUrlProd + 'emails/updatemark',
    DEBUG: false,
    score: baseUrl + 'data/panelistscore',
    scoreProd: baseUrlProd + 'data/panelistscore',
    PRIMARY_DASHBOARD: 'dashboard',
    SPACEY_DASHBOARD: 'spacey',
    SPACEY2019_DASHBOARD: 'spacey 2019',
    getCompany: baseUrlCompany,
    getCompanyProd: baseUrlCompanyProd,
    getCompany2019: baseUrlCompany2019,
    getCompanyProd2019: baseUrlCompany2019Prod,
    spaceyUrl: baseUrl + 'emails',
    spaceyUrlProd: baseUrlProd + 'emails',
    spacey2019Url: baseUrl + 'spaceyq1',
    spacey2019UrlProd: baseUrlProd + 'spaceyq1',
    spaceyEmail: baseUrl + 'spaceyemail',
    VisualizeUrl: VisualizeUrl,
    VisualizeUrlProd: VisualizeUrlProd,
    CRON_LOGS_DASHBOARD: 'cron_logs',
    importjoblogs: baseUrl + 'importjoblogs',
    importjoblogsProd: baseUrlProd + 'importjoblogs',
    emailbodypopupdata: baseUrl + 'emailbodyhtml',
    emailbodypopupdataprod: baseUrlProd + 'emailbodyhtml',
    DEDUPLICATES_DASHBOARD: 'deduplicates',
    deduplicates: baseUrlProd + 'deduplicates',
    deduplicates_local: baseUrl + 'deduplicates',
    deduplicate_search: baseUrlProd + 'deduplicate-search',
    deduplicates_local_search: baseUrl + 'deduplicate-search',
    states: baseUrl + 'states',
    states_prod: baseUrlProd + 'states',
    render_html: render_html_url,
    render_processed_html: render_processed_html_url,
    render_pdf: render_pdf_url,
    dashboards: dashboards,
    assigncopy: baseUrl + 'assigncopy',
    assigncopy_prod: baseUrlProd + 'assigncopy',
    read_email: baseUrl + 'reademail',
    read_email_prod: baseUrlProd + 'reademail',
    render_company_local: render_company_url_local,
    render_company_prod: render_company_url_prod,
    all_prediction_url_local: all_prediction_url_local,
    all_prediction_url_prod: all_prediction_url_prod,
    spaceyEmailProd: baseUrlProd + 'spaceyemail',
    baseUrlApi,
    newProductEntry:newProductEntry,
    pdfUpload:baseUrlApiProduction + 'uploadpdf',
    baseUrlApiProduction,
    sector_url_local: sector_url_local,
    sector_url_prod: sector_url_prod,
    category_url_local: category_url_local,
    category_url_prod: category_url_prod,
    mailingtype_url_local: mailingtype_url_local,
    mailingtype_url_prod: mailingtype_url_prod,
    seccompany_url_local: seccompany_url_local,
    seccompany_url_prod: seccompany_url_prod,
    sendmailURL_local: sendmailURL_local,
    sendmailURL_prod: sendmailURL_prod,
    getForwardApiURL_local: getForwardApiURL_local,
    getForwardApiURL_prod: getForwardApiURL_prod,
    getAttachements_local: getAttachements_local,
    getAttachements_prod: getAttachements_prod,
    deleteemailapi_local: deleteemailapi_local,
    deleteemailapi_prod: deleteemailapi_prod,
    downloadapi_local: downloadapi_local,
    downloadapi_prod: downloadapi_prod,
    uploadattachment_local: uploadattachment_local,
    uploadattachment_prod: uploadattachment_prod,
    tiny_mce_api_key: tiny_mce,
    render_apc_process: render_apc_process_url,
    html_pdf_service_local: html_pdf_service_url_local,
    html_pdf_service_prod: html_pdf_service_url_prod,
    companyPredProd: companyPredProd,
    baseUrl: baseUrl,
    baseUrlProd: baseUrlProd,
    uploadpdf: upload_pdf_base_url + "uploadpdf",
    uploadpdf_prod: upload_pdf_base_url_prod + "uploadpdf",
    product_images: upload_pdf_base_url + "imagelist",
    product_images_prod: upload_pdf_base_url_prod + "imagelist",
    images_rotate: upload_pdf_base_url + "rotatepdf",
    images_rotate_prod: upload_pdf_base_url_prod + "rotatepdf",
    product_admin_listing: product_admin_listing,
    sign_in_url: 'http://localhost:8080/',
    //sign_in_prod_url: 'http://localhost:8080/',
    sign_in_prod_url: 'https://login.competiscan.com/',
    role_permission_url: 'http://localhost:5001/userRolesAndPermissions',
    role_permission_prod_url: 'https://api2.competiscan.com/users/v1/userRolesAndPermissions',
    domain_name: "localhost",
    //domain_prod_name: "localhost",
    domain_prod_name: ".competiscan.com",
    sign_out_url: "http://localhost:5001/logout",
    sign_out_prod_url: "https://api2.competiscan.com/users/v1/logout",
    auto_sign_out_url: "http://localhost:5001/autoLogout",
    auto_sign_out_prod_url: "https://api2.competiscan.com/users/v1/autoLogout",
    refresh_token_url: "http://localhost:5001/refreshToken",
    refresh_token_prod_url: "https://api2.competiscan.com/users/v1/refreshToken",
    direct_mail_pdf: upload_pdf_base_url + "openpdf",
    direct_mail_pdf_prod: upload_pdf_base_url_prod + "openpdf",
    direct_mail_temp_grid: direct_mail_temp_grid,
    direct_mail_temp_grid_prod: direct_mail_temp_grid,
    baseUrlProductv2: baseUrlProductv2,
    baseUrlProductv2Prod: baseUrlProductv2Prod,
    allowed_sectors_url: "http://localhost:5001/roleProductTaxonomy",
    allowed_sectors_prod_url: "https://api2.competiscan.com/users/v1/roleProductTaxonomy",
    visual_annotation_url: ml_annotation_tool_base_url + "v3/muid-data",
    visual_annotation_prod_url: ml_annotation_tool_base_url_prod + "v3/muid-data",
    admin_frontend_url: 'http://localhost:8082/',
    admin_frontend__prod_url: 'https://admin.competiscan.com',
    text_extraction_url: 'http://localhost:5402/',
    text_extraction_prod_url: 'https://ocr.competiscan.com/easyocrprocessedimage/',
    senderDetails: baseUrl + 'senderdetails',
    senderDetailsProd: baseUrlProd + 'senderdetails',
    upload_service_url: upload_endpoint + "product-upload",
    upload_service_url_prod: upload_endpoint_prod + "product-upload",
    upload_file_attachment_url: upload_endpoint + "fileupload",
    upload_file_attachment_url_prod: upload_endpoint_prod + "fileupload",
    product_log_url: upload_pdf_base_url + 'adminlog',
    product_log_url_prod: upload_pdf_base_url_prod + "adminlog",
    resample_url: upload_pdf_base_url + 'resample3',
    resample_url_prod: upload_pdf_base_url_prod + 'resample3',
    download_file_path: upload_pdf_base_url + "downloadfile",
    download_file_path_prod: upload_pdf_base_url_prod + "downloadfile",
    soft_delete_url: upload_pdf_base_url_prod + "productarchieve",
    soft_delete_url_prod: upload_pdf_base_url_prod + "productarchieve",
    archeive_link: archeive_link,
    archeive_link_prod: archeive_link,
    get_user: upload_pdf_base_url_prod + "adminsearchrawdata",
    get_user_prod: upload_pdf_base_url_prod + "adminsearchrawdata",
    send_email: send_email_link,
    send_email_prod: send_email_link_prod,
    product_headline_predict: "https://ocr.competiscan.com/generate-headline/",
    DMTM_filename : baseUrlApiProduction + 'dmsourcename'
}
